export default function RedirectCard({ request, onCancel, message }) {
  // Check if there's an error message indicating already submitted
  const isAlreadySubmitted = message?.ERROR?.message === "already_submitted";
  
  // Determine the actual request state
  const requestState = isAlreadySubmitted ? "already_submitted" : request;
  
  return (
    <div className="justify-center items-center md:inset-0 h-modal sm:h-full">
      <div className="relative px-4 w-full max-w-md h-full md:h-auto">
        <div className="bg-white rounded-lg shadow">
          <div className="p-6 text-center">
            {requestState === "good" ? <GoodRequest /> : 
             requestState === "already_submitted" ? <AlreadySubmittedRequest /> : 
             <BadRequest />}
            
            {requestState === "good" ? <GoodRequestText /> : 
             requestState === "already_submitted" ? 
             <h3 className="mb-5 text-lg font-normal text-gray-500">
               {message?.ERROR?.details || "You have already submitted a form. Please visit the nearest branch to get help from our agents."}
             </h3> : 
             <AlreadySubmittedText />}

            {requestState === "good" && (
              <>
                <p className="text-gray-500 mb-4">
                  Redirecting you to our Facebook page in a few seconds…
                </p>
                <button
                  onClick={onCancel}
                  className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg text-gray-700"
                >
                  Cancel Redirect
                </button>
              </>
            )}
            
          </div>
        </div>
      </div>
    </div>
  );
}

function BadRequest() {
  return (
    <svg
      className="mx-auto mb-4 w-14 h-14 text-red-400"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );
}

function AlreadySubmittedRequest() {
  return (
    <svg
      className="mx-auto mb-4 w-14 h-14 text-yellow-400"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );
}

function GoodRequest() {
  return (
    <svg
      className="mx-auto mb-4 w-14 h-14 text-green-400"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );
}

function GoodRequestText() {
  return (
    <h3 className="mb-5 text-lg font-normal text-gray-500">
      We received your request and you will receive a mail from us as soon as
      possible.
    </h3>
  );
}

function AlreadySubmittedText() {
  return (
    <h3 className="mb-5 text-lg font-normal text-gray-500">
      You have already submitted a form. Please visit the nearest branch to get help from our agents.
    </h3>
  );
}
/*
function BadRequestText() {
  return (
    <h3 className="mb-5 text-lg font-normal text-gray-500">
      Unfortunately! your submission failed. Please contact our customer service
      team.
    </h3>
  );
}
*/